import { skipToken, useQuery } from "@apollo/client/react";
import {
  ProjectBannerQuery,
  ProjectBannerQueryVariables,
} from "gql/generated/types";
import { PROJECT_BANNER } from "gql/queries";
import { PortalBanner } from "./PortalBanner";
import { SiteBanner } from "./SiteBanner";

interface ProjectBannerProps {
  projectIdentifier?: string;
}
export const ProjectBanner: React.FC<ProjectBannerProps> = ({
  projectIdentifier,
}) => {
  const { data: projectBannerData } = useQuery<
    ProjectBannerQuery,
    ProjectBannerQueryVariables
  >(
    PROJECT_BANNER,
    projectIdentifier
      ? { variables: { identifier: projectIdentifier } }
      : skipToken,
  );
  const { text, theme } = projectBannerData?.project.banner || {};
  if (!text || !theme) {
    return null;
  }
  return <PortalBanner banner={<SiteBanner text={text} theme={theme} />} />;
};
